import { Icon } from '../Icon';
import type { IconProps } from '../types';

export function TrezorIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <path d="M18.02 5.57C18.02 2.526 15.305 0 12 0S5.978 2.527 5.978 5.57v1.78H3.5v12.805L11.999 24l8.501-3.847V7.405h-2.478zm-8.973 0c0-1.435 1.3-2.584 2.952-2.584 1.653 0 2.952 1.149 2.952 2.584v1.78H9.047zm8.029 12.518-5.077 2.297-5.077-2.297v-7.695h10.154z" />
    </Icon>
  );
}

TrezorIcon.displayName = 'TrezorIcon';
